import { createSlice } from "@reduxjs/toolkit";
import { fetchDeleteProvidersPhotos, fetchProviderInformation, fetchProvidersPhotos, fetchUpdateProviderInformation, fetchUpdateProvidersPhotos } from "./ProviderOverviewActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";


const providerOverviewInformation = createSlice({
  name: "providerOverviewInformation",
  initialState: {
    isProviderOverviewDataLoading: false,
    providerOverviewData: [],
    providerOverviewError: null,
    providerOverviewErrorMsg: ""
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProviderInformation.pending, (state) => {
        state.isProviderOverviewDataLoading = true;
        state.providerOverviewError = null;
      })
      .addCase(fetchProviderInformation.fulfilled, (state, action) => {
        state.isProviderOverviewDataLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data.metadata.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.providerOverviewError = false;
            state.providerOverviewData = [];
          }
          else {
            state.providerOverviewError = true;
            state.providerOverviewErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.providerOverviewError = false;
          state.providerOverviewData = action.payload.data.data.providerResponseDTO[0];
        }
      })
      .addCase(fetchProviderInformation.rejected, (state, action) => {
        state.isProviderOverviewDataLoading = false;
        state.providerOverviewError = action.error.message;
      })
      .addCase(fetchUpdateProviderInformation.pending, (state) => {
        state.isProviderOverviewDataLoading = true;
        state.providerOverviewError = null;
      })
      .addCase(fetchUpdateProviderInformation.fulfilled, (state, action) => {
        state.isProviderOverviewDataLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data.metadata.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.providerOverviewError = false;
            state.providerOverviewData = [];
          }
          else {
            state.providerOverviewError = true;
            state.providerOverviewErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.providerOverviewError = false;
          state.providerOverviewData = action.payload;
        }
      })
      .addCase(fetchUpdateProviderInformation.rejected, (state, action) => {
        state.isProviderOverviewDataLoading = false;
        state.providerOverviewError = action.error.message;
      });
  },
});


const providerOverviewPhotos = createSlice({
  name: "providerOverviewPhotos",
  initialState: {
    isProfilePhotosLoading: false,
    profilePhotosData: {},
    profilePhotosError: null,
    profilePhotosErrorMsg: ""
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProvidersPhotos.pending, (state) => {
        state.isProfilePhotosLoading = true;
        state.profilePhotosError = null;
      })
      .addCase(fetchProvidersPhotos.fulfilled, (state, action) => {
        state.isProfilePhotosLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data.metadata.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.profilePhotosError = false;
            state.profilePhotosData = {};
          }
          else {
            state.profilePhotosError = true;
            state.profilePhotosErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.profilePhotosError = false;
          state.profilePhotosData = action.payload.data.data.mediaItemResponseDTO;
        }
      })
      .addCase(fetchProvidersPhotos.rejected, (state, action) => {
        state.isProfilePhotosLoading = false;
        state.profilePhotosError = action.error.message;
      })
      .addCase(fetchDeleteProvidersPhotos.pending, (state) => {
        state.isProfilePhotosLoading = true;
        state.profilePhotosError = null;
      })
      .addCase(fetchDeleteProvidersPhotos.fulfilled, (state, action) => {
        state.isProfilePhotosLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data.metadata.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.profilePhotosError = false;
            state.profilePhotosData = {};
          }
          else {
            state.profilePhotosError = true;
            state.profilePhotosErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.profilePhotosError = false;
          state.profilePhotosData = action.payload.data.data.mediaItemResponseDTO;
        }
      })
      .addCase(fetchDeleteProvidersPhotos.rejected, (state, action) => {
        state.isProfilePhotosLoading = false;
        state.profilePhotosError = action.error.message;
      })
      .addCase(fetchUpdateProvidersPhotos.pending, (state) => {
        state.isProfilePhotosLoading = true;
        state.profilePhotosError = null;
      })
      .addCase(fetchUpdateProvidersPhotos.fulfilled, (state, action) => {
        state.isProfilePhotosLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data.metadata.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.profilePhotosError = false;
            state.profilePhotosData = {};
          }
          else {
            state.profilePhotosError = true;
            state.profilePhotosErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.profilePhotosError = false;
          state.profilePhotosData = action.payload.data.data.mediaItemResponseDTO;
        }
      })
      .addCase(fetchUpdateProvidersPhotos.rejected, (state, action) => {
        state.isProfilePhotosLoading = false;
        state.profilePhotosError = action.error.message;
      })
  },
});


export const { addUpdateProviderInformation } =
  providerOverviewInformation.actions;
export const providerOverviewInformationReducer =
  providerOverviewInformation.reducer;
export const providerOverviewPhotosReducer = providerOverviewPhotos.reducer;